import React, { useState, useEffect, useRef } from 'react';
import './DynamicCarousel.css';
import CarouselItem from './CarouselItem';
import { Grid2, Typography } from '@mui/material';
import { Receta } from '../interfaces/RecetaDetalle.interface';

function DynamicCarousel({ section, onLoadItems, iconoCentrado = false, favorito = false }) {
  const [items, setItems] = useState<Receta[]>([]);
  const [startIndex, setStartIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  //const [loading, setLoading] = useState(true);

  const carouselContainerRef = useRef(null);

  useEffect(() => {
    const loadItems = async () => {
      try {
        const data = await onLoadItems(); // Llama a la función de carga de recetas
        setItems(data); // Actualiza el estado de los items
        calculateItemsPerPage();
      } catch (error) {
        console.error('Error loading items:', error);
      } finally {
        //setLoading(false); // Desactiva el loader
      }
    };

    loadItems();
  }, [onLoadItems]);

  const calculateItemsPerPage = () => {
    if (carouselContainerRef.current) {
      const containerWidth = carouselContainerRef.current.offsetWidth;
      const isMobile = window.innerWidth <= 768;
      const itemWidth = isMobile ? 295 : 295; // Tamaño menor para móviles
      const newItemsPerPage = Math.floor(containerWidth / itemWidth);
      setItemsPerPage(newItemsPerPage < 2 ? 2 : newItemsPerPage);
    }
  };

  useEffect(() => {
    calculateItemsPerPage();
    window.addEventListener('resize', calculateItemsPerPage);

    return () => {
      window.removeEventListener('resize', calculateItemsPerPage);
    };
  }, []);

  const handleNext = () => {
    if (startIndex + itemsPerPage < items.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrev = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  const visibleItems = items.slice(startIndex, startIndex + itemsPerPage);
  
  if (!Array.isArray(visibleItems) || (Array.isArray(visibleItems) && visibleItems.length === 0)) {
    return (
        <div>
            {/* En blanco hasta que se tenga info */}
        </div>
    );
  }
  
  return (
    <Grid2 className="carousel-section">
      {section !== null &&
        <Grid2 size={12} className={`title-icon-container ${iconoCentrado ? 'centered' : ''}`}>
          <img className="dynamic-carousel-icon" src={section.imagen} alt={section.nombre} />
          <Typography className="dynamic-carousel-title">{section.nombre}</Typography>
        </Grid2>
      }
      <Grid2 className="carousel-container" ref={carouselContainerRef}>
        <Grid2 container className="carousel-items" spacing={0}>
          {Array.isArray(visibleItems) && visibleItems.length > 0 ? (
            visibleItems.map((item) => (
              <Grid2 key={item.id}>
                <CarouselItem
                  imageSrc={item.urlImagen}
                  title={item.nombre}
                  time={item.tiempoPreparacion}
                  description={item.descripcion}
                  id={item.id}
                  timeOfDay={section}
                  alergico={item.esAlergico}
                  favorito={favorito}
                />
              </Grid2>
            ))
          ) : (
            <p>No hay elementos disponibles</p>
          )}
        </Grid2>
        <div className={startIndex === 0 ? "carousel-arrow left-disabled" : "carousel-arrow left"} onClick={handlePrev}>
            <span className="material-icons" style={{ fontSize: '24px' }}>arrow_back</span>
        </div>
        <div className={startIndex + itemsPerPage >= items.length ? "carousel-arrow right-disabled" : "carousel-arrow right"} onClick={handleNext}>
            <span className="material-icons" style={{ fontSize: '24px' }}>arrow_forward</span>
        </div>
      </Grid2>
    </Grid2>
  );
}

export default DynamicCarousel;
